// extracted by mini-css-extract-plugin
export default {"landing":"Landing_landing__cjCQE","content":"Landing_content__yM7ug","contact":"Landing_contact__1iiGe","buttonsWrpr":"Landing_buttonsWrpr__+iiOZ"};